import firebase from 'firebase/app';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Login {

  loginWithEmail(usuario, success, onError) {
    firebase.auth().signInWithEmailAndPassword(usuario.email, usuario.password)
      .then(result => {
        success(result.user)
      })
      .catch(error => onError(Error.guardarError(error)))
  }

  loginWithFacebook(success, onError) {
    let provider = new firebase.auth.FacebookAuthProvider()
    try {
      firebase.auth().signInWithPopup(provider)
        .then(result => {
          success(result.user)
        })
        .catch(error => onError(Error.guardarError(error)))
    } catch{
      console.log('reintentando login con facebook')
      provider = new firebase.auth.FacebookAuthProvider()
      firebase.auth().signInWithPopup(provider)
        .then(result => {
          success(result.user)
        })
        .catch(error => onError(Error.guardarError(error)))
    }

  }

  loginWithGoogle(success, onError) {
    let provider = new firebase.auth.GoogleAuthProvider()
    try{
      firebase.auth().signInWithPopup(provider)
      .then(result => {
        success(result.user)
      })
      .catch(error => onError(Error.guardarError(error)))
    }catch{
      console.log('reintentando login con google')
      provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider)
      .then(result => {
        success(result.user)
      })
      .catch(error => onError(Error.guardarError(error)))
    }
  }

  logOut(e) {
    return firebase.auth().signOut()
      .then()
      .catch(error => Error.guardarError(error))
  }


}


